(function () {
  'use strict';

  var mediaByHandle = {
  "acostumbrador-3603": {
    "BL": "42219819073784"
  },
  "almilla-clasica-1600-bebe-nina": {
    "BL": "42094310162680",
    "ZM": "42094353154296",
    "CZ": "42094320189688",
    "RJ": "42094328152312",
    "RS": "42094340636920",
    "VA": "42094341816568"
  },
  "almilla-clasica-1600-bebe-nino": {
    "BL": "42094524924152",
    "ZM": "42094526955768",
    "ZB": "42094526267640",
    "RJ": "42094525513976",
    "VS": "42094541406456"
  },
  "almilla-victoria-1601": {
    "BL": "30614067347704",
    "RS": "30614068297976",
    "VQ": "30614068723960"
  },
  "baby-body-basico-2131-bebe-nina": {
    "RS": "42094567325944"
  },
  "baby-body-basico-2131-bebe-nino": {
    "BL": "42094575354104",
    "ZC": "42094575714552"
  },
  "baby-body-camiseta-2116-bebe-nina": {
    "BL": "30614296920312",
    "RL": "30614300000504",
    "RS": "30614304391416"
  },
  "baby-body-camiseta-2116-bebe-nino": {
    "BL": "30682854785272",
    "ZI": "30682855866616",
    "ZC": "30682855276792"
  },
  "baby-body-manga-corta-con-broches-2130-bebe-nina": {
    "RS": "30614382543096"
  },
  "baby-body-manga-corta-con-broches-2130-bebe-nino": {
    "BL": "30891850957048",
    "ZC": "30682925891832"
  },
  "baby-body-sin-manga-2101-bebe-nina": {
    "BL": "30614204350712",
    "ZM": "30682815561976",
    "FC": "30614205563128"
  },
  "baby-body-sin-manga-2101-bebe-nino": {
    "ZM": "30751443550456",
    "ZS": "30891845779704"
  },
  "blusa-alba-1370-bebe-nina": {
    "ST": "31032938103032"
  },
  "body-casablanca-1367": {
    "BL": "42094755119352"
  },
  "boxer-boston-1014": {
    "NG": "30783753715960",
    "ZW": "30783758303480",
    "VB": "30783756927224"
  },
  "boxer-corto-1007-hombre": {
    "NG": "42094837432568",
    "GA": "42094836056312",
    "GO": "42094837301496"
  },
  "boxer-corto-1007-nino": {
    "NG": "42094933311736"
  },
  "boxer-largo-1004": {
    "NG": "42111325274360"
  },
  "boxer-sport-1008": {
    "BL": "30631093207288",
    "NG": "30631094190328",
    "ZY": "30631095959800",
    "GC": "30631093666040",
    "ZI": "30631094976760"
  },
  "camisa-escolar-3301-nina": {
    "BL": "42219814584568",
    "ZC": "42219820024056",
    "BG": "42219807047928"
  },
  "camisa-escolar-3301-nino": {
    "BL": "42219878613240",
    "ZC": "42219877007608",
    "BG": "42219872190712"
  },
  "camiseta-basica-1104": {
    "BL": "30631258751224",
    "NG": "30631255933176",
    "ZM": "30631257506040",
    "HC": "30631252295928",
    "VY": "30631256785144",
    "CA": "30782811406584",
    "CZ": "30631258030328",
    "NA": "30631253737720",
    "RZ": "30782815895800",
    "TE": "30782816485624",
    "VT": "30631255015672",
    "RO": "30782814748920"
  },
  "camiseta-clasica-1100-hombre": {
    "BL": "42112810385656",
    "NG": "42112853508344",
    "ZM": "42113102676216",
    "GG": "42112790987000",
    "GO": "42112833454328",
    "TE": "42113056932088",
    "VO": "42112885293304",
    "VS": "42113102151928",
    "ZR": "42113112473848"
  },
  "camiseta-clasica-1100-nino": {
    "BL": "42219821891832"
  },
  "camiseta-deportiva-1116": {
    "BL": "30631297679608",
    "NG": "30631298302200",
    "ST": "30631298629880"
  },
  "camiseta-ensueno-1102": {
    "BL": "42219757240568"
  },
  "camiseta-madrid-1153": {
    "NG": "42127725461752",
    "BV": "42127852765432",
    "PL": "42127798731000",
    "VF": "42127837004024"
  },
  "camiseta-shirley-1105-mujer": {
    "ST": "42112885227768"
  },
  "camiseta-surf-1107": {
    "NG": "30630228558072",
    "GR": "30630227181816",
    "GP": "30630224560376",
    "ZY": "30630230065400",
    "AB": "30783635554552",
    "VV": "30783635849464"
  },
  "chemise-polycotton-escolar-2816-nina": {
    "BL": "42219772575992",
    "AD": "42219766350072",
    "RJ": "42219771855096",
    "ZC": "42219772182776",
    "BG": "42219768316152"
  },
  "chemise-polycotton-escolar-2816-nino": {
    "BL": "42219862098168",
    "AD": "42219856396536",
    "RJ": "42219865604344",
    "ZC": "42219860590840",
    "BG": "42219853644024"
  },
  "chemise-polycotton-escolar-2817": {
    "BL": "42219779784952",
    "ZC": "42219778048248",
    "BG": "42219773264120"
  },
  "chemise-princesa-con-mangas-escolar-2834": {
    "BL": "42219788009720",
    "AD": "42219780538616",
    "RJ": "42219784863992"
  },
  "falda-escolar-3103": {
    "ZM": "42219799544056"
  },
  "franela-chester-1302": {
    "BL": "30631305576696",
    "NG": "30631306002680",
    "BR": "30631309213944",
    "CZ": "30631310164216",
    "CF": "30783138791672",
    "ZR": "32844851314936"
  },
  "franela-chester-manga-larga-1326": {
    "BL": "32845134070008",
    "NG": "30783396020472",
    "RZ": "30783396643064",
    "ZW": "30783397101816",
    "VN": "32845150388472"
  },
  "franela-clasica-cuello-o-1300-hombre": {
    "BL": "30630280691960",
    "NG": "30630291636472",
    "ZM": "30630299107576",
    "ME": "30630289047800",
    "TE": "30630294388984",
    "VO": "30630297043192",
    "GO": "30630281904376",
    "RJ": "30630293012728",
    "AF": "30783639879928",
    "ZC": "30783640305912"
  },
  "franela-clasica-cuello-o-1300-mujer": {
    "BL": "30631214186744",
    "NG": "30631209763064",
    "ZM": "30631206322424",
    "ME": "30631209009400",
    "ZR": "30631207010552",
    "RS": "30783116312824",
    "AF": "30783114969336",
    "GO": "30631208714488",
    "RJ": "30631215628536",
    "TE": "30631205961976",
    "VO": "30631214776568",
    "ZC": "30783117656312"
  },
  "franela-clasica-cuello-o-1300-nina": {
    "BL": "42219758223608",
    "VI": "42219764318456",
    "AF": "42219756912888",
    "RJ": "42219758354680",
    "ZC": "42219764646136"
  },
  "franela-clasica-cuello-o-1300-nino": {
    "BL": "42219847811320",
    "AF": "42219840569592",
    "RJ": "42219844894968",
    "ZC": "42219852759288",
    "VI": "42219836637432"
  },
  "franela-cuello-en-v-1301": {
    "BL": "30630419726584",
    "NG": "30630414156024",
    "ZM": "30630418678008",
    "ME": "30630416449784"
  },
  "franela-cuello-o-blister-1371-hombre": {
    "BL": "31032938135800"
  },
  "franela-cuello-v-1317": {
    "BL": "30631342506232",
    "NG": "30631339786488",
    "ZM": "30631342047480",
    "VD": "30783167725816",
    "RI": "32845063880952",
    "TE": "30631339360504",
    "CF": "30631341654264"
  },
  "franela-eddy-1307": {
    "BL": "30631324451064",
    "NG": "30631323631864",
    "RI": "30631321567480",
    "ZW": "30783152554232",
    "NZ": "32844951814392",
    "CZ": "30631325106424",
    "VT": "30631325532408"
  },
  "franela-fit-1308": {
    "BL": "30783657443576",
    "NG": "30783656329464",
    "ZM": "30783657672952",
    "GO": "30783656919288"
  },
  "franela-gym-sin-mangas-1309": {
    "BL": "30630263423224",
    "NG": "30630260605176",
    "ZM": "30630262178040",
    "ME": "30630259556600"
  },
  "franela-manga-1325": {
    "BL": "32845103530232",
    "VN": "32845103563000",
    "ZW": "32845103595768"
  },
  "franela-manga-corta-celine-1387": {
    "NG": "30631361118456",
    "VT": "30631360659704",
    "TM": "30783209734392",
    "LL": "30631362527480",
    "RÑ": "30631362461944"
  },
  "franela-manga-larga-1313": {
    "BL": "30630444990712",
    "NG": "30630443188472",
    "ZM": "30630446301432",
    "ME": "32845038387448"
  },
  "franela-manga-larga-celine-1389": {
    "NG": "30631371342072",
    "ZM": "30631372128504",
    "VO": "32856676663544",
    "TT": "30631368261880",
    "VT": "32856676696312",
    "NZ": "30960513384696"
  },
  "franela-manga-larga-con-punos-1331": {
    "BL": "30630545785080",
    "NG": "30630547194104",
    "ZM": "30630544146680"
  },
  "franela-manga-raglan-1310": {
    "BL": "30783782846712",
    "ZM": "30783782748408",
    "ME": "30783782617336",
    "GO": "30783782420728"
  },
  "franela-rania-1329-mujer": {
    "ST": "31032939413752"
  },
  "franela-tie-dye-1324-hombre": {
    "NG": "30630488375544",
    "ZM": "30630487752952",
    "VO": "30630486049016"
  },
  "franela-tie-dye-1324-mujer": {
    "NG": "30630488375544",
    "ZM": "30630487752952",
    "VO": "30630486049016"
  },
  "franela-tie-dye-1324-nina": {
    "RS": "30680971575544",
    "TM": "30891902402808"
  },
  "franela-tie-dye-1324-nino": {
    "ZM": "30751466946808",
    "VO": "30613840036088",
    "TM": "30751466324216"
  },
  "franela-vivo-raglan-1321": {
    "NG": "30630464225528",
    "GC": "30630463308024"
  },
  "interior-clasico-1000-hombre": {
    "BL": "30631056965880"
  },
  "interior-hit-1003": {
    "NG": "31037803856120",
    "ZM": "30631066927352",
    "GP": "30631066501368"
  },
  "interior-kid-1005": {
    "ST": "31033231376632"
  },
  "interior-malibu-1001": {
    "NG": "30631060177144",
    "ZM": "31037910188280",
    "GC": "30631059128568",
    "GO": "30631059357944",
    "ZI": "30631060832504",
    "ZG": "30631061487864"
  },
  "jogger-3073": {
    "NG": "30783769116920",
    "ZM": "30783769739512"
  },
  "jogger-3075": {
    "ZM": "42219874287864"
  },
  "jogger-jaspeado-3074": {
    "NG": "30631425704184",
    "ZM": "30631425933560",
    "GO": "30631425147128"
  },
  "legging-3036": {
    "NG": "30631419117816",
    "ME": "30631376486648"
  },
  "pantaleta-angie-1229": {
    "ST": "31032991383800"
  },
  "pantaleta-atlanta-1231": {
    "RS": "31033015533816",
    "VA": "31033016484088"
  },
  "pantaleta-corte-bajo-1209": {
    "BL": "30631488028920",
    "NG": "30631487111416",
    "ME": "30631486488824",
    "DO": "32838105792760",
    "GG": "32838105825528"
  },
  "pantaleta-hilo-princess-1206": {
    "BL": "30631477903608",
    "NG": "30631477018872",
    "DO": "32837975933176",
    "GG": "32837975965944"
  },
  "pantaleta-hot-pant-1211-hombre": {
    "BL": "32838233686264",
    "NG": "30631492190456",
    "DO": "32838233620728",
    "GG": "32838233653496"
  },
  "pantaleta-hot-pant-1211-mujer": {
    "BL": "32838233686264",
    "NG": "30631492190456",
    "DO": "32838233620728",
    "GG": "32838233653496"
  },
  "pantaleta-monaco-1208": {
    "BL": "30631482851576",
    "NG": "32838059458808",
    "ND": "32838059491576"
  },
  "pantaleta-queen-1205": {
    "BL": "30631473152248",
    "NG": "30631473774840",
    "ME": "30631472464120",
    "DO": "32837911347448",
    "GG": "32837915902200",
    "MF": "32837923078392"
  },
  "pantalon-con-elastico-escolar-3022-nino": {
    "ZM": "42219872944376"
  },
  "pantalon-de-pijama-1443": {
    "NG": "30630759006456",
    "GO": "30630760972536",
    "ZY": "30630759956728",
    "ZW": "32872460484856"
  },
  "pantalon-escolar-3011": {
    "ZM": "42219797872888"
  },
  "pantalon-mono-deportivo-escolar-3008-nina": {
    "ZM": "42219795874040"
  },
  "pantalon-mono-deportivo-escolar-3008-nino": {
    "ZM": "42219863998712"
  },
  "pantalon-sin-pinzas-escolar-3015": {
    "ZM": "42219868913912"
  },
  "pijama-boxer-1442": {
    "NG": "30630742884600",
    "GO": "30630741934328",
    "ZY": "30630743572728"
  },
  "short-deportivo-2613": {
    "NG": "30783776456952",
    "ZM": "30783776751864"
  },
  "short-escolar-2607": {
    "ZM": "42219765334264"
  },
  "short-vivo-2614": {
    "NG": "30781900423416",
    "GO": "30781899571448"
  },
  "sueter-con-cierre-escolar-2913-nina": {
    "ZM": "42219789058296"
  },
  "sueter-con-cierre-escolar-2913-nino": {
    "ZM": "42219863212280"
  },
  "vestido-aixa-1510": {
    "NG": "30631454081272",
    "RZ": "30631454507256",
    "MV": "30631454998776",
    "VY": "30631455457528",
    "VB": "30783308759288",
    "ZW": "30783309709560",
    "FC": "30960563454200"
  },
  "vestido-new-york-3121": {
    "NG": "31707422425336",
    "ZW": "31707422916856",
    "VN": "31707423047928",
    "BM": "33907863617784"
  }
};
  var boundAttribute = 'data-ovejita-color-gallery-bound';

  function normalize(value) {
    return String(value || '')
      .replace(/ñ/gi, '\uE000')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
      .replace(/\uE000/g, 'Ñ');
  }

  function compact(value) {
    return normalize(value).replace(/[^A-Z0-9Ñ]/g, '');
  }

  function getSkuKey(sku) {
    var match = compact(sku).match(/^(\d{4})([A-Z0-9Ñ]{2})/);
    return match ? match[1] + match[2] : null;
  }

  function hasNativeVariantMedia(variant) {
    if (!variant) return false;

    return Boolean(
      (variant.featured_media && variant.featured_media.id) ||
      (variant.featured_image && (variant.featured_image.id || variant.featured_image.src))
    );
  }

  function getHandle(container) {
    return String(container.dataset.productHandle || '').trim().toLowerCase();
  }

  function getThumbs(container) {
    return Array.prototype.slice.call(container.querySelectorAll('[data-product-thumb]'));
  }

  function getThumbSearchText(thumb) {
    var image = thumb.querySelector('img');
    return compact([
      thumb.getAttribute('href'),
      thumb.getAttribute('title'),
      thumb.getAttribute('aria-label'),
      image && image.getAttribute('src'),
      image && image.getAttribute('srcset'),
      image && image.getAttribute('alt'),
      image && image.getAttribute('title')
    ].filter(Boolean).join(' '));
  }

  function findThumbBySku(container, skuKey) {
    if (!skuKey) return null;

    return getThumbs(container).find(function (thumb) {
      return getThumbSearchText(thumb).indexOf(skuKey) !== -1;
    }) || null;
  }

  function findThumbByMap(container, handle, color) {
    var productMap = mediaByHandle[handle];
    var mediaId = productMap && productMap[color];
    if (!mediaId) return null;

    return getThumbs(container).find(function (thumb) {
      return String(thumb.dataset.id || '') === String(mediaId);
    }) || null;
  }

  function activateThumb(thumb) {
    if (!thumb) return false;

    // Motion listens for focus on gallery thumbnails. Dispatching focus is safe
    // even while the slider is still initializing and never follows the link.
    thumb.dispatchEvent(new Event('focus'));
    return true;
  }

  function correctVariantImage(container, variant, delay) {
    if (!variant || hasNativeVariantMedia(variant)) return;

    var skuKey = getSkuKey(variant.sku);
    if (!skuKey) return;

    var color = skuKey.slice(4, 6);
    var handle = getHandle(container);

    window.setTimeout(function () {
      var thumb = findThumbBySku(container, skuKey)
        || findThumbByMap(container, handle, color);

      activateThumb(thumb);
    }, delay || 0);
  }

  function getInitialVariant(container) {
    var variantJson = container.querySelector('[data-current-variant-json]');
    if (!variantJson) return null;

    try {
      return JSON.parse(variantJson.value || variantJson.textContent);
    } catch (error) {
      return null;
    }
  }

  function bindProduct(container) {
    if (!container || container.hasAttribute(boundAttribute)) return;

    container.setAttribute(boundAttribute, '');
    container.addEventListener('variantChange', function (event) {
      correctVariantImage(container, event.detail && event.detail.variant, 0);
    });

    // Covers direct product URLs such as ?variant=... when the selected
    // variant has no native featured media.
    correctVariantImage(container, getInitialVariant(container), 150);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('.product-section[data-product-handle]')) {
      bindProduct(scope);
    }

    scope.querySelectorAll('.product-section[data-product-handle]').forEach(bindProduct);
  }

  function init() {
    scan(document);

    new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });

    window.addEventListener('load', function () {
      document.querySelectorAll('.product-section[data-product-handle]').forEach(function (container) {
        correctVariantImage(container, getInitialVariant(container), 0);
      });
    }, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
